import { computed, defineComponent } from 'vue';
import { useWhitelabelListStore } from '@/store/dictionary/whitelabel-list.store';
import { storeToRefs } from 'pinia';
import { WhitelabelListItem } from '@/models/dictionary/whitelabel-list.model';
import { useEnvStore } from '@/store/env.store';
import { DictionaryWlListItem } from '@/models/whitelabel-list/whitelabel-list.model';

enum MultiWhitelabelDialog {
  UPDATE_MODEL_VALUE = 'update:modelValue',
  UPDATE_SELECTED_WHITELABEL_SLUG_LIST = 'update:selectedWhitelabelSlugList',
  ADD_WHITELABEL = 'addWhitelabel',
}

export default defineComponent({
  name: 'MultiWhitelabelDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    selectedWhitelabelSlugList: {
      type: Array as () => DictionaryWlListItem[],
      default: () => [],
    },
  },
  emits: [
    MultiWhitelabelDialog.UPDATE_MODEL_VALUE,
    MultiWhitelabelDialog.UPDATE_SELECTED_WHITELABEL_SLUG_LIST,
    MultiWhitelabelDialog.ADD_WHITELABEL,
  ],
  setup(props, { emit }) {
    const whitelabelListStore = useWhitelabelListStore();
    const { isWhitelabelListLoading, whitelabelList } = storeToRefs(whitelabelListStore);

    const { WHITELABEL_ID } = storeToRefs(useEnvStore());

    const selectedWhitelabelList = computed<DictionaryWlListItem[]>({
      get: () => props.selectedWhitelabelSlugList,
      set: (value: DictionaryWlListItem[]) => {
        emit(MultiWhitelabelDialog.UPDATE_SELECTED_WHITELABEL_SLUG_LIST, value);
      },
    });

    const isVisible = computed<boolean>({
      get: () => props.modelValue,
      set: (value: boolean) => emit(MultiWhitelabelDialog.UPDATE_MODEL_VALUE, value),
    });

    const availableWhitelabelList = computed<WhitelabelListItem[]>(() =>
      whitelabelList.value.filter(({ id }: WhitelabelListItem) => id !== WHITELABEL_ID.value),
    );

    const isSelectedWhitelabelSlugListEmpty = computed<boolean>(() => selectedWhitelabelList.value.length === 0);

    const closeDialog = (): void => {
      isVisible.value = false;
    };

    const addWhitelabel = () => {
      emit(MultiWhitelabelDialog.ADD_WHITELABEL, selectedWhitelabelList.value);
      closeDialog();
    };

    return {
      isVisible,
      closeDialog,
      addWhitelabel,
      isWhitelabelListLoading,
      availableWhitelabelList,
      isSelectedWhitelabelSlugListEmpty,
      selectedWhitelabelList,
    };
  },
});
